"use client";

import dynamic from "next/dynamic";

import type { ChatAnimationProps } from "./ChatAnimation";

const ChatAnimation = dynamic(() => import("./ChatAnimation"));

export default function ChatAnimationWrapper(props: ChatAnimationProps) {
  return <ChatAnimation {...props} />;
}
